//提货单

import UltMeta, { Meta } from "./UltMeta/index";

class GoodsState extends UltMeta {
    FINISHED = new Meta(3, "已完成");
    INVALIDING = new Meta(4, "作废中");
    INVALID = new Meta(5, "已作废");
}

export const GOODS_STATE = new GoodsState();

/**
 *
 */
class QueryType extends UltMeta {
    ONE = new Meta(1, "作为提货单位");
    TWO = new Meta(2, "作为供货单位");
}

export const QUERY_TYPE = new QueryType();
